import React, { useState, useEffect } from "react";
import {
  Route,
  Routes,
  Navigate,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";

import { TranslatedString } from "@bosch/bt-ui";

import withErrorHandler from "../components/ErrorHandler";
import LoggedInPages from "./LoggedInPages";
import PageNotFoundPage from "../pages/PageNotFoundPage";
import LoginPage from "../pages/LoginPage";
import LoginPageLayout from "../layouts/LoginPageLayout";
import DefaultLayout from "../layouts/DefaultLayout";
import HomePage from "../pages/HomePage";
import { useToken } from "../components/useToken";
import LogoutPage from "./LogoutPage";

function getReturnUrl(queryString) {
  const queryParams = new URLSearchParams(queryString);

  const returnUrl = queryParams.get("return-url");

  if (returnUrl === "" || returnUrl === "/login" || returnUrl === "/logout")
    return null;

  return returnUrl;
}

const Page = () => {
  const { token, deleteToken, setToken, isLoggedIn } = useToken();
  const [isDirty, setIsDirty] = useState(false);

  const returnUrl = getReturnUrl(location.search);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/*"
        element={
          <Routes>
            <Route
              path="/login"
              element={
                isLoggedIn() ? (
                  <Navigate to={returnUrl || "/"} replace />
                ) : (
                  <LoginPageLayout>
                    <LoginPage token={token} setToken={setToken} />
                  </LoginPageLayout>
                )
              }
            />
            <Route path="/logout" element={<LogoutPage />} />
            <Route
              path="/"
              exact
              element={
                <DefaultLayout
                  token={token}
                  activeMenuId="home-page"
                  pageTitle={<TranslatedString stringId="title-home-page" />}
                  pageSubtitle={<TranslatedString stringId="subtitle-home-page" />}
                  isDirty={isDirty}
                  setIsDirty={setIsDirty}
                >
                  <HomePage token={token} parentUrl="/" />
                </DefaultLayout>
              }
            />
            <Route
              path="/*"
              exact
              element={
                <LoggedInPages
                  token={token}
                  deleteToken={deleteToken}
                  isLoggedIn={isLoggedIn}
                >
                  <Routes></Routes>
                </LoggedInPages>
              }
            />
            <Route element={<PageNotFoundPage />} />
          </Routes>
        }
      />
    )
  );

  return <RouterProvider router={router} />;
};

export default withErrorHandler(React.memo(Page));
